if (!customElements.get("product-form")) {
  class a extends HTMLElement {
    constructor() {
      super(),
        (this.form = this.querySelector("form")),
        (this.form.querySelector("[name=id]").disabled = !1),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        (this.freeSampleButton = this.form.querySelector(
          ".variant-free-sample-button"
        )),
        (this.cartButton = document.querySelector('[data-cart="button"]')),
        (this.cartCount = document.querySelector('[data-cart="count"]')),
        (this.cartWording = document.querySelector('[data-cart="wording"]')),
        (this.variantId = this.dataset.variantId),
        (this.inventory = this.dataset.inventory),
        (this.evenPacks = this.dataset.evenPacks),
        (this.cartType = this.dataset.cartType),
        (this.outOfStockMessage =
          this.dataset.outOfStockMessage ||
          "We currently only have ${adjustedInventory} packs in stock."),
        (this.submitButton = this.querySelector('[type="submit"]')),
        (this.cartNotification = document.querySelector("cart-notification")),
        (this.cart = document.querySelector("cart-drawer")),
        (this.cartNotificationNew = document.querySelector(
          "#cartNotificationNew"
        )),
        null !== this.freeSampleButton &&
          this.freeSampleButton.addEventListener(
            "click",
            this.checkFreeSample.bind(this)
          ),
        this.initProductFormData();
    }
    initProductFormData() {
      this.productFormData = window.productFormData || {};
      var t = this.productFormData;
      if (
        ((this.defaultOneSqMeterVarId =
          t.oneSqMeter.defaultVarId || "44308094058742"),
        t.oneSqMeter.customRules)
      )
        try {
          this.oneSqMeterCustomRules = JSON.parse(t.oneSqMeter.customRules);
        } catch (t) {
          console.log(t);
        }
    }
    getOneSqMeterVarId() {
      try {
        for (let t = 0; t < this.oneSqMeterCustomRules.length; t++) {
          var e = this.oneSqMeterCustomRules[t];
          if (
            e.variantId &&
            productConditionsUtils.checkConditions(
              e.conditions,
              this.productFormData.product,
              this.productFormData.product.collection_ids
            )
          )
            return e.variantId;
        }
      } catch (t) {
        console.log(t);
      }
      return this.defaultOneSqMeterVarId;
    }
    onSubmitHandler(t) {
      t.preventDefault();
      var t = this.querySelector('[type="submit"]'),
        e = "/cart/add.js",
        r = Number(this.variantId),
        a = document.querySelector("product-quantity-input").dataset.units;
      "1sqm" === a
        ? this.addOneSquareMetre(t, e, r)
        : this.standardProductSetup(a, t, e, r);
    }
    showLoading(t) {
      t && (t.setAttribute("aria-disabled", !0), t.classList.add("loading")),
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
    }
    hideLoading(t) {
      t && (t.classList.remove("loading"), t.removeAttribute("aria-disabled")),
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
    }
    checkReadyToAdd(t, e) {
      e = Number(e);
      return !(
        t.classList.contains("loading") ||
        ("true" == t.dataset.accessoryRestriction
          ? (this.querySelector('[type="submit"]').disabled = !0)
          : e < 1 || (this.handleErrorMessage(), this.showLoading(t), 0))
      );
    }
    getShopifyCart() {
      return fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((t) => t.json())
        .catch((t) => {
          console.error("Error:", t);
        });
    }
    getStartingDateAttribute() {
      const deliveryDateContainer = document.querySelector('.future-delivery-date-container');
      if (deliveryDateContainer && deliveryDateContainer.dataset.date) {
        return { starting_date: deliveryDateContainer.dataset.date };
      }
      return {};
    }
    async standardProductSetup(t, e, r, a) {
      var i = Number(t);
      this.checkReadyToAdd(e, t) &&
        ((t = { items: [{ id: a, quantity: i }] }),
        (() => {
          const startingDateAttr = this.getStartingDateAttribute();
          if (Object.keys(startingDateAttr).length > 0) {
            t.attributes = startingDateAttr;
            localStorage.setItem('starting_date_variant_id', a);
          }
        })(),
        "drawer" == this.cartType
          ? this.submitATCWithCartDrawer(t, e)
          : this.submitATC(r, t, e));
    }
    async addOneSquareMetre(t, e, r) {
      if (this.checkReadyToAdd(t, 1)) {
        var a = Number(
          document.querySelector("product-quantity-input").dataset.price
        );
        const s = this.getOneSqMeterVarId();
        var i = await this.getShopifyCart();
        i && i.items && i.items.some((t) => t.id == s)
          ? (this.cart && this.cart.open(), this.hideLoading(t))
          : ((i = {
              "Main Product": document.querySelector("product-quantity-input")
                .dataset.productTitle,
              "Product Variant": document.querySelector(
                "product-quantity-input"
              ).dataset.variantTitle,
              _mainProductUrl: window.location.pathname,
              "Product Unit": "m2",
            }),
            this.dataset.featuredImage &&
              (i._mainProductImage = this.dataset.featuredImage),
            (a = { items: [{ quantity: a, id: s, properties: i }] }),
            (() => {
              const startingDateAttr = this.getStartingDateAttribute();
              if (Object.keys(startingDateAttr).length > 0) {
                a.attributes = startingDateAttr;
                localStorage.setItem('starting_date_variant_id', s);
              }
            })(),
            "drawer" == this.cartType
              ? this.submitATCWithCartDrawer(a, t)
              : this.submitATC(e, a, t));
      }
    }
    isEven(t) {
      return t % 2 == 0;
    }
    async submitATC(t, e, r) {
      fetch(t, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(e),
      })
        .then((t) => t.json())
        .then((e) => {
          if (e.status) {
            let t = this.inventory;
            var r = this.isEven(Number(t));
            "true" === this.evenPacks && !1 === r && (t = this.inventory - 1),
              this.handleErrorMessage(
                422 === e.status
                  ? this.outOfStockMessage.replace("${adjustedInventory}", t)
                  : e.description
              );
          } else
            this.updateCartIcon(),
              this.viewUpsell(),
              this.cartNotificationModal();
        })
        .catch((t) => {
          console.error(t);
        })
        .finally(() => {
          r.classList.remove("loading"),
            r.removeAttribute("aria-disabled"),
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
        });
    }
    objectToFormData(t, e, r) {
      var a,
        i,
        s = e || new FormData();
      for (a in t)
        t.hasOwnProperty(a) &&
          ((i = r ? `${r}[${a}]` : a),
          "object" != typeof t[a] || t[a] instanceof File
            ? s.append(i, t[a])
            : this.objectToFormData(t[a], s, i));
      return s;
    }
    async submitATCWithCartDrawer(t, e) {
      const a = Object.assign({}, t);
      t = fetchConfig("javascript");
      this.cart &&
        ((a.sections = this.cart.getSectionsToRender().map((t) => t.id)),
        (a.sections_url = window.location.pathname),
        this.cart.setActiveElement(document.activeElement)),
        (t.body = JSON.stringify(a)),
        fetch("" + routes.cart_add_url, t)
          .then((t) => t.json())
          .then((e) => {
            if (e.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: a.id,
                errors: e.errors || e.description,
                message: e.message,
              });
              let t = this.inventory;
              var r = this.isEven(Number(t));
              "true" === this.evenPacks && !1 === r && (t = this.inventory - 1),
                this.handleErrorMessage(
                  422 === e.status
                    ? `We currently only have ${t} packs in stock. Please phone us on 01133 200 223 to find out when we are restocking this item`
                    : e.description
                ),
                void (this.error = !0);
            } else
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: a.id,
                  cartData: e,
                }),
                (this.error = !1),
                this.cart &&
                  (this.cart.classList.remove("is-empty"),
                  this.cart.renderContents(e));
          })
          .catch((t) => {
            console.error(t);
          })
          .finally(() => {
            $("cart-drawer").toggleClass("animate active");
            $('#cart-icon').addClass('cart-full');
            e.classList.remove("loading"),
              e.removeAttribute("aria-disabled"),
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              ),
              this.cart &&
                this.cart.classList.contains("is-empty") &&
                this.cart.classList.remove("is-empty");
          });
    }
    cartNotificationModal() {
      this.cartNotificationNew.classList.remove("cart-notification-new-none"),
        this.cartNotificationNew.classList.add(
          "cart-notification-new-outer-container"
        );
      var t = document.getElementById("cartNotification-productTitle"),
        e = document.querySelector("product-quantity-input"),
        t =
          (t &&
            (t.textContent =
              "Default Title" !== e.dataset.variantTitle
                ? e.dataset.variantTitle
                : e.dataset.productTitle),
          document.querySelector(
            ".cart-notification-new-inner-container-heading"
          ));
      t && (t.textContent = "Item added to cart!");
    }
    async viewUpsell() {
      var t = this.querySelector("#product-upsells");
      t && t.classList.add("is-active");
    }
    async updateCartIcon() {
      var e = await this.getCart(),
        r = [];
      for (let t = 0; t < e.length; t++) {
        var a = e[t].quantity;
        r.push(a);
      }
      var t = e.length;
      this.cartButton.classList.add("site-header__cart--has-items"),
        (this.cartCount.textContent = t),
        1 < Number(t)
          ? (this.cartWording.textContent = "items")
          : (this.cartWording.textContent = "item");
    }
    handleErrorMessage(t = !1) {
      (this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper")),
        (this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          )),
        t
          ? (this.errorMessageWrapper.removeAttribute("hidden"),
            (this.errorMessage.textContent = t))
          : this.errorMessageWrapper.setAttribute("hidden", "");
    }
    async checkFreeSample(t) {
      if ("true" != this.freeSampleButton.dataset.accessoryRestriction) {
        var e = Number(this.freeSampleButton.dataset.variantid),
          r = await this.getCart(),
          a = [],
          i = [];
        for (let t = 0; t < r.length; t++) {
          var s = r[t],
            o = s.variant_id,
            n = s.price,
            s = s.variant_title;
          ((0 === n && s.includes("Sample")) ||
            (0 === n && s.includes("sample"))) &&
            i.push(!0),
            o === e && a.push(!0);
        }
        2 < i.length
          ? alert("You cannot have more than 3 samples in your cart")
          : 0 !== a.length
          ? alert("Free Sample already in cart")
          : this.addFreeSample(e);
      }
    }
    async addFreeSample(t) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [t]: 1 } }),
      })
        .then(async (t) => {
          !0 === t.ok &&
            ((this.freeSampleButton.innerHTML = "Sample Added!"),
            this.updateCartIcon());
        })
        .catch((t) => {
          console.error("Error:", t);
        });
    }
    async getCart() {
      return new Promise((e) => {
        fetch("/cart.js")
          .then((t) => t.json())
          .then((t) => {
            e(t.items);
          })
          .catch((t) => console.log("error = ", t));
      });
    }
  }
  class b extends a {
    async addOneSquareMetre(t, e, r) {
      if (this.checkReadyToAdd(t, 1)) {
        var a = document.querySelector("product-quantity-input"),
          i = Number(a.dataset.pricePerMetresSquared);
        const o = r;
        var r = a.dataset.productTitle,
          a = a.dataset.variantTitle,
          s = await this.getShopifyCart();
        s &&
        s.items &&
        s.items.some((t) => t.id == o && t.properties._isOneSqMeterItem)
          ? (this.cart && this.cart.open(), this.hideLoading(t))
          : ((s = {
              "Main Product": r,
              "Product Variant": a,
              _mainProductUrl: window.location.pathname,
              _isOneSqMeterItem: !0,
              _productUnitPrice: i,
              "Product Unit": "m2",
            }),
            this.dataset.featuredImage &&
              (s._mainProductImage = this.dataset.featuredImage),
            (r = { items: [{ quantity: 1, id: o, properties: s }] }),
            (() => {
              const startingDateAttr = this.getStartingDateAttribute();
              if (Object.keys(startingDateAttr).length > 0) {
                r.attributes = startingDateAttr;
                localStorage.setItem('starting_date_variant_id', o);
              }
            })(),
            "drawer" == this.cartType
              ? this.submitATCWithCartDrawer(r, t)
              : this.submitATC(e, r, t));
      }
    }
  }
  customElements.define("product-form", b);
}